import React from "react";
import {HubStatsCount, HubStatsTitle, HubStatsWrapper} from "apps/BWW_PLAY_HUB/components/HubStats/styles";
import { getHubStats } from "apps/BWW_PLAY_HUB/modules/selectors/hub_stats";
import { useSelector } from "react-redux";
import { HubStatsProgressBar, HubStatsProgressBarWithCount } from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsProgressBar";
import { EnumStatsType, getPercent, getProfileValue } from "apps/BWW_PLAY_HUB/components/HubStats/utils";
import { HubStatsLegend } from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsLegend";


export const UserNumberPerfectContests: React.FC = () => {
	const { pp } = useSelector(getHubStats);
	const { user_number_perfect_contests, total_contests_played } = pp;

	if (!total_contests_played || !user_number_perfect_contests) {
		return null;
	}

	const items = [
		{
			type   : EnumStatsType.pp,
			value  : user_number_perfect_contests,
			percent: getPercent(user_number_perfect_contests, total_contests_played),
			title: 'Perfect Contests',
		},
	];

	return (
		<HubStatsWrapper>
			<HubStatsTitle>Number of perfect contests achieved</HubStatsTitle>
			<HubStatsProgressBarWithCount>
				<HubStatsCount>{ getProfileValue(user_number_perfect_contests) }</HubStatsCount>
				<HubStatsProgressBar items={items} bg_color={'#2D5371'} />
			</HubStatsProgressBarWithCount>
			<HubStatsLegend items={items} />
		</HubStatsWrapper>
	);
};
